/* Caddie for Zanetta Sg v1.8.0: the sign-up panel. No dependencies.
   A small non-blocking panel (not a full-screen modal). Opens once the shopper has scrolled past 60% of a
   screen (after the first 4 s) or after the delay set in Theme settings > Sign-up, whichever comes first;
   waits while a drawer is open or the shopper is typing. Shown once every 30 days per browser, never again
   after a sign-up, never on the bag page or at checkout. Esc and the close button dismiss it; while it is
   open, Tab stays inside it. The form is a native Shopify customer form: without JavaScript the panel never
   shows and the footer form still works. */
(function () {
  'use strict';
  var KEY = 'zt-signup', SRC = 'zt-signup-src', DAYS30 = 30 * 864e5;
  function store(s) { try { return s ? window.sessionStorage : window.localStorage; } catch (e) { return null; } }
  function get(k, s) { try { var st = store(s); return st ? st.getItem(k) : null; } catch (e) { return null; } }
  function put(k, v, s) { try { var st = store(s); if (st) st.setItem(k, v); } catch (e) {} }
  function del(k, s) { try { var st = store(s); if (st) st.removeItem(k); } catch (e) {} }
  function state() { try { return JSON.parse(get(KEY) || 'null'); } catch (e) { return null; } }
  function mark(s) { var o = state(); if (o && o.s === 'subscribed') return; put(KEY, JSON.stringify({ s: s, t: Date.now() })); }

  /* which sign-up form was sent, so the result opens the panel only when the panel sent it */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (f && f.id && /^Signup(Panel|Footer)-form$/.test(f.id)) put(SRC, f.id, true);
  }, true);
  var src = get(SRC, true); if (src) del(SRC, true);
  if (document.querySelector('[data-su-ok]')) mark('subscribed');

  var panel = document.querySelector('[data-signup]');
  if (!panel) return;
  var form = panel.querySelector('form');
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])';
  var last = null, isOpen = false, ticking = false;

  function lift() {
    /* sit above the product page's sticky add bar while it is showing */
    var bar = document.querySelector('.satc.is-on'), h = 0;
    if (bar) { var top = bar.getBoundingClientRect().top; if (top < window.innerHeight) h = Math.round(window.innerHeight - top); }
    panel.style.setProperty('--su-lift', h + 'px');
  }
  function onScrollOpen() { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; if (isOpen) lift(); }); } }
  function onKey(e) {
    if (!isOpen || document.documentElement.classList.contains('has-drawer')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab' && panel.contains(document.activeElement)) {
      var f = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], end = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && a === first) { e.preventDefault(); end.focus(); }
      else if (!e.shiftKey && a === end) { e.preventDefault(); first.focus(); }
    }
  }
  function open(withResult) {
    if (isOpen) return;
    isOpen = true;
    if (!withResult) mark('shown');
    last = document.activeElement;
    panel.hidden = false;
    lift();
    requestAnimationFrame(function () { requestAnimationFrame(function () { panel.classList.add('is-open'); }); });
    var target = (withResult && panel.querySelector('[data-su-ok],[data-su-err]')) || panel.querySelector('.su-h');
    if (target) { if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
    document.addEventListener('keydown', onKey, true);
    window.addEventListener('scroll', onScrollOpen, { passive: true });
    window.addEventListener('resize', onScrollOpen);
    panel.dispatchEvent(new CustomEvent('signup:open', { bubbles: true }));
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    mark('dismissed');
    panel.classList.remove('is-open');
    panel.hidden = true;
    document.removeEventListener('keydown', onKey, true);
    window.removeEventListener('scroll', onScrollOpen);
    window.removeEventListener('resize', onScrollOpen);
    if (last && last !== document.body && document.contains(last)) last.focus({ preventScroll: true });
    panel.dispatchEvent(new CustomEvent('signup:close', { bubbles: true }));
  }
  panel.addEventListener('click', function (e) { if (e.target.closest('[data-su-close]')) { e.preventDefault(); close(); } });

  /* the panel's own form was sent: show its result straight away. Shopify gives the result to every customer
     form on the page, so an error is cleared from the footer copy (a thank-you there is still true) */
  if (form && src === form.id && panel.querySelector('[data-su-ok],[data-su-err]')) {
    var foot = document.getElementById('SignupFooter-form');
    if (foot && foot.querySelector('[data-su-err]')) {
      Array.prototype.forEach.call(foot.querySelectorAll('[data-su-err]'), function (m) { m.parentNode.removeChild(m); });
      var fi = foot.querySelector('input[type="email"]'); if (fi) { fi.removeAttribute('aria-invalid'); fi.removeAttribute('aria-describedby'); fi.value = ''; }
    }
    open(true); return;
  }

  if (/(^|\/)(cart|checkouts?)(\/|$)/.test(location.pathname)) return;
  var st = state();
  if (st && (st.s === 'subscribed' || Date.now() - (+st.t || 0) < DAYS30)) return;

  var delay = Math.max(5, +panel.getAttribute('data-delay') || 20) * 1000, t0 = Date.now(), timer = null, fired = false;
  function busy() {
    var a = document.activeElement;
    /* v1.9.0: also waits while the cookie banner is open */
    return document.documentElement.classList.contains('has-drawer') || !!document.querySelector('.cb.is-open') || !!(a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName));
  }
  function trigger() {
    if (fired) return;
    clearTimeout(timer);
    if (busy()) { timer = setTimeout(trigger, 2000); return; }
    fired = true;
    window.removeEventListener('scroll', onScroll);
    open(false);
  }
  function onScroll() { if (Date.now() - t0 > 4000 && window.scrollY > window.innerHeight * 0.6) trigger(); }
  timer = setTimeout(trigger, delay);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
